<template>
  <div>
    <Form
      ref="editModel"
      :model="editModel"
      :rules="ruleValidate"
      :label-width="100"
    >
      <!-- <FormItem label="服务" prop="DicId">
        <Select v-model="editModel.DicId">
          <Option
            v-for="(item, index) in ServiceSelect"
            :value="item.dictionaryID"
            :key="index"
            >{{ item.dictionaryValue }}
          </Option>
        </Select>
      </FormItem> -->
      <FormItem label="服务名" prop="dicName">
        <Input v-model="editModel.dicName" readonly></Input>
      </FormItem>
      <FormItem label="xml配置" prop="xmlinfo">
        <Input
          v-model="editModel.xmlinfo"
          placeholder="请输入xml配置"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 10 }"
        ></Input>
      </FormItem>
    </Form>
    <Upload
      ref="uploadFile"
      :action="uploadUrl"
      :headers="headers"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    >
      <!-- :show-upload-list="false" -->
      <Button icon="ios-cloud-upload-outline">选择压缩包</Button>
    </Upload>
    <div>{{ fileName }}</div>
    <div class="text-center modal-foter">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('editModel')"
        >确 定</Button
      >
    </div>
  </div>
</template>
<script>
import token from "../../../utils/token.js";
export default {
  props: ["currentData"],
  data: function () {
    return {
      ServiceSelect: [],
      fileName: "",
      headers: "",
      uploadUrl: "",
      editModel: {
        dicId: "",
        dicName: "",
        dicCode: "",
        xmlinfo: "",
        updateFilePath: "",
      },
      SecretTypeSelect: [],
      ruleValidate: {
        VersionName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        VersionCode: [
          {
            required: true,
            message: "不能为空",
          },
        ],
        DicName: [
          {
            required: true,
            message: "不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.SecretTypeSelect = this.$common.getJsonData("clientType");
    let baseUrl = localStorage.getItem("baseURL");
    this.uploadUrl = baseUrl + "/clientversion/uploadrar";
    this.headers = { Authorization: "Bearer " + token.getToken() };

    this.editModel = this.currentData;

    if (
      this.editModel.updateFilePath &&
      this.editModel.updateFilePath.indexOf("/") >= 0
    ) {
      this.fileName = this.editModel.updateFilePath.substr(
        this.editModel.updateFilePath.lastIndexOf("/") + 1
      );
    }
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          this.$api.post("serviceInfo/update", this.editModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("更新成功");
              this.returnBack();
              this.resetData();
              this.$emit("loadData");
            }
          });
        }
      });
    },

    resetData() {
      for (let key in this.editModel) {
        this.editModel[key] = "";
      }
      this.$refs["editModel"].resetFields();
    },
    selectTreeData: function (data) {
      //  this.DicIdtemp= data[0].organID;
      //   this.editModel.organName = data[0].title;
    },
    selectdicTreeData: function (data) {
      if (data && data.length > 0) {
        if (data[0].isroot) {
          alert("请选择子节点");
          return;
        }
        this.DicIdtemp = data[0].id;
        this.DicNametemp = data[0].title;
      }
    },
    okdicModal() {
      this.editModel.DicId = this.DicIdtemp;
      this.editModel.DicName = this.DicNametemp;
    },
    canceldicModal() {},

    selectClientTreeData: function (data) {
      console.log(`selected item:${JSON.stringify(data)}`);

      let showclient = [];
      let showclientSN = [];

      data.forEach(function (item, idnex) {
        if (!item.isroot) {
          showclient.push(item.title);
          showclientSN.push(item.id);
        }
      });
      this.ClientSNtemp = showclientSN;
      this.ClientNametemp = showclient.join(",");
    },
    okclientModal() {
      this.editModel.ClientSN = this.ClientSNtemp;
      this.editModel.ClientName = this.ClientNametemp;
    },
    cancelclientModal() {},
    //导入
    uploadSuccess: function (response, file, fileList) {
      if (response.statusCode == 200) {
        this.$Message.success("上传成功");
        this.editModel.updateFilePath = response.data;
        this.fileName = "";
      } else {
        this.$Message.success(response.msg);
      }
    },

    cancel: function () {},
    uploadError: function (error, file, fileList) {
      this.$Message.success("上传失败");
    },
  },
};
</script>
<style scoped>
.limitshow {
  max-width: 10em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>